import { useSyncExternalStore } from 'react';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'qaytim.admin.theme';

type Listener = () => void;

const listeners = new Set<Listener>();
let current: Theme | null = null;

function preferred(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // Xususiy rejimda `localStorage` yozishga ruxsat bermasligi mumkin — bu xato emas.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function apply(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  document.documentElement.style.colorScheme = theme;
}

export const themeStore = {
  get(): Theme {
    if (current === null) current = preferred();
    return current;
  },

  set(theme: Theme): void {
    current = theme;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // Saqlanmasa ham joriy sessiya uchun mavzu ishlaydi.
    }
    apply(theme);
    for (const listener of listeners) listener();
  },

  toggle(): void {
    themeStore.set(themeStore.get() === 'dark' ? 'light' : 'dark');
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

/**
 * Mavzuni ilova ko'tarilishida bir marta qo'llaydi.
 *
 * `index.html` da inline skript yo'q — admin panel sessiya bilan himoyalangan ichki asbob va
 * birinchi kadrdagi oq chaqnash bu yerda hal qilinishi shart bo'lgan muammo emas.
 */
export function initTheme(): void {
  apply(themeStore.get());
}

export function useTheme(): Theme {
  return useSyncExternalStore(
    themeStore.subscribe,
    () => themeStore.get(),
    () => 'light' as Theme,
  );
}
